module.exports = __webpack_public_path__ + "img/card1.2f69af63.png";